{
  "invalidSelection": "Selected {selectedCount, plural, one {date} other {dates}} unavailable."
}
